import { ConversionType } from "./ConversionType";
import { EntityTypes } from "./EntityTypes";

export class AddConversionModel {  
    public type: ConversionType;
    public parentId: string | undefined;
    public parentType: EntityTypes | undefined;
}